import { Routes } from '@angular/router';
import { AppPage, LazyModuleConfig, LoginFormPage } from 'jk-service';
import { StockHomeComponent } from './components/home/stock-home.component';// ### 不同project 名稱不同
import { Mtrki01BillComponent } from 'mtr';
import { Mtrki04Component } from 'mtr';


import { StockPage } from './stk/stock/stock.component';
import { Stkpb04Component } from './stk/stkpb04/stkpb04.component';
import { Stkpb05Component } from './stk/stkpb05/stkpb05.component';
import { Stkpi01BillComponent } from './stk/stkpi01/stkpi01BillPkg.component';
import { Stkpi13BillComponent } from './stk/stkpi13/stkpi13BillPkg.component';
import { Stkpi17BillComponent } from './stk/stkpi17/stkpi17BillPkg.component';
import { Stkpi19BillComponent } from './stk/stkpi19/stkpi19BillPkg.component';
import { Stkpi20BillComponent } from './stk/stkpi20/stkpi20BillPkg.component';
import { Stkpq08Page } from './stk/stkpq08/stkpq08.component';
import { Stkpq09Page } from './stk/stkpq09/stkpq09.component';
import { Stkpq10Page } from './stk/stkpq10/stkpq10.component';
import { Stkpq13Component } from './stk/stkpq13/stkpq13.component';
import { Stkpq14Component } from './stk/stkpq14/stkpq14.component';
import { Stkpq15Component } from './stk/stkpq15/stkpq15.component';
import { Stkpq16Component } from './stk/stkpq16/stkpq16.component';
import { Stkpq17Component } from './stk/stkpq17/stkpq17.component';
import { Stkpq18Component } from './stk/stkpq18/stkpq18.component';
import { Stkpq19Component } from './stk/stkpq19/stkpq19.component';


export const moduleConfigs: LazyModuleConfig[] = [//### 以下模組數不同
/*  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    preload: true,
    priority: 1
  },
  {
    path: 'sys',
    loadChildren: () => import('sys').then(m => m.SysModule),
    preload: true,
    priority: 1
  }
  */
];

export const appPages: AppPage[] = [// ###
  { title: '首頁', url: '/home', icon: 'home', id: 'home', isCheckPower: false, checked: true, hint: '一切從家開始', }, // ###
];

// routes 的 path 都不要加 / 開頭
export const routes: Routes = [//###
  { path: '', component: StockHomeComponent, },
  { path: 'login-form', component: LoginFormPage },
  { path: 'sys/login-form', component: LoginFormPage },
  //{ path: '', loadComponent: () => import('./components/home/stock-home.component').then(m => m.StockHomeComponent) },
  { path: 'home', component: StockHomeComponent, },
  //{ path: 'mtr/mtrki01', component: Mtrki01BillComponent, },
  //{ path: 'mtr/mtrki04', component: Mtrki04Component, },
  //{ path: 'home', loadComponent: () => import('./components/home/stock-home.component').then(m => m.StockHomeComponent) },
  // Lazy loaded feature modules
  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    data: { preload: false, priority: 3, preloadDelay: 2000 }
  },
  {
    path: 'stk/stock',
    component: StockPage,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpb04',
    component: Stkpb04Component,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpb05',
    component: Stkpb05Component,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpi01',
    component: Stkpi01BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpi13',
    component: Stkpi13BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpi17',
    component: Stkpi17BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpi19',
    component: Stkpi19BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpi20',
    component: Stkpi20BillComponent,
    //canActivate: [ AuthGuardService ]
  },
  {
    path: 'stk/stkpq08',
    component: Stkpq08Page,
  },
  {
    path: 'stk/stkpq09',
    component: Stkpq09Page,
  },
  {
    path: 'stk/stkpq10',
    component: Stkpq10Page,
  },
  {
    path: 'stk/stkpq13',
    component: Stkpq13Component,
  },
  {
    path: 'stk/stkpq14',
    component: Stkpq14Component,
  },
  {
    path: 'stk/stkpq15',
    component: Stkpq15Component,
  },
  {
    path: 'stk/stkpq16',
    component: Stkpq16Component,
  },
  {
    path: 'stk/stkpq17',
    component: Stkpq17Component,
  },
  {
   path: 'stk/stkpq18',
    component: Stkpq18Component,
  },
  {
    path: 'stk/stkpq19',
    component: Stkpq19Component,
  },
  // stock end =========
  /*
  {
    path: 'mtr',
    loadChildren: () => import('mtr').then(m => m.MtrModule),
    data: { preload: false, priority: 2, preloadDelay: 1000 }
  },
  {
    path: 'sys',
    loadChildren: () => import('sys').then(m => m.SysModule),
    data: { preload: true, priority: 3, preloadDelay: 500 }
  },*/
  {
    path: '**',
    redirectTo: 'home',
  },
];
